import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'quoteandbind.eu.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'quoteandbind.eu.views.riskAnalysis.lossesAndViolation.Losses & Violations',
        defaultMessage: 'Losses & Violations'
    },
    miscellaneaousReportsTabHeading: {
        id: 'quoteandbind.eu.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'quoteandbind.eu.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    }
});
